import {RepositoryFactory} from '@/api/factory/repositoryFactory'
const Repository = RepositoryFactory.get('mdtex2html')
import get from 'lodash-es/get'

const state = {}
const actions = {
  async convert(_, params) {
    const res = await Repository.convert(params)
    return get(res, 'data', {})
  },
}
const mutations = {}
const getters = {}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
